import { Organization } from 'types'
import { EXCLUDED_KEYS } from './EXCLUDED_KEYS'

// computeMonthlyMetrics.ts
export interface Product {
  productName: string
  mediaSpend: number // was string
  price: number
  grossProfit: number
  qty: number
  startDate: string
  endDate: string
  payer: string
}

export interface Deal {
  products: Product[]
  dealStatus: string
  // ...other fields
}

export interface AggregatedMetric {
  [product: string]: number
}
export const computeMonthlyMetrics = (org: Organization, month: string): { [service: string]: number } => {
  const [year, mon] = month.split('-').map(Number)
  const monthStart = new Date(year, mon - 1, 1)
  const monthEnd = new Date(year, mon, 0)

  const metrics: { [service: string]: number } = {}
  const monthToMonthMetrics: { [service: string]: number } = {}

  org.deals.forEach((deal: Deal) => {
    if (!Array.isArray(deal.products)) return

    deal.products.forEach(product => {
      const prodStart = new Date(product.startDate)
      const prodEnd = new Date(product.endDate)

      const price = parseFloat(String(product.price)) || 0
      const grossProfit = parseFloat(String(product.grossProfit)) || 0
      const mediaSpendRaw = parseFloat(String(product.mediaSpend)) || 0
      const qty = parseFloat(String(product.qty)) || 1 // fallback to 1

      let serviceName = product.productName
      if (serviceName === 'Paid Search - Media Spend') {
        serviceName = 'Paid Search Advertising'
      }

      if (deal?.dealStatus === 'Month To Month') {
        // const monthlySpend = mediaSpendRaw * qty
        const monthlySpend = mediaSpendRaw
        if (monthlySpend > 0) {
          metrics[serviceName] = (metrics[serviceName] || 0) + monthlySpend
          monthToMonthMetrics[serviceName] = (monthToMonthMetrics[serviceName] || 0) + monthlySpend
        }
      } else {
        if (prodStart <= monthEnd && prodEnd >= monthStart && product.payer !== 'Client') {
          const mediaSpend = price - grossProfit
          if (mediaSpend > 0) {
            // const totalSpend = mediaSpend * qty
            const totalSpend = mediaSpend
            const yearDiff = prodEnd.getFullYear() - prodStart.getFullYear()
            const monthDiff = prodEnd.getMonth() - prodStart.getMonth()
            const totalMonths = yearDiff * 12 + monthDiff + 1
            const monthlySpend = totalSpend

            metrics[serviceName] = (metrics[serviceName] || 0) + monthlySpend
          }
        }
      }
    })
  })

  return metrics
}

export const computeOverallGrossTotals = (
  organizations: {
    aggregatedMetrics?: AggregatedMetric[]
    monthlyAggregatedMetrics?: AggregatedMetric
  }[],
  month?: string
): { [product: string]: number } => {
  const totals: { [product: string]: number } = {}

  organizations.forEach(org => {
    if (month && org.monthlyAggregatedMetrics) {
      // Use the monthly computed metrics
      Object.entries(org.monthlyAggregatedMetrics).forEach(([product, value]) => {
        if (product === 'Projected Budget') return
        if (product === 'Paid Social Management Fee') return
        if (product === 'Display Management Fee') return
        if (product === 'Reddit Advertising') return
        if (product === 'Branding Guide') return
        if (product === 'Paid Social Management Fee') return
        if (product === 'Display Management Fee') return

        const normalizedKey = product === 'Paid Search - Media Spend' ? 'Paid Search Advertising' : product

        totals[normalizedKey] = (totals[normalizedKey] || 0) + value
      })
    } else if (org.aggregatedMetrics && Array.isArray(org.aggregatedMetrics)) {
      // Use overall aggregatedMetrics from backend
      org.aggregatedMetrics.forEach(metricObj => {
        const product = Object.keys(metricObj)[0]
        const value = metricObj[product] || 0

        if (product === 'Projected Budget') return

        const normalizedKey = product === 'Paid Search - Media Spend' ? 'Paid Search Advertising' : product

        totals[normalizedKey] = (totals[normalizedKey] || 0) + value
      })
    }
  })

  return totals
}

// Optionally, if you prefer an array of single-key objects:
export const computeOverallGrossTotalsArray = (
  organizations: { aggregatedMetrics?: AggregatedMetric[] }[]
): AggregatedMetric[] => {
  const totals = computeOverallGrossTotals(organizations)
  console.log('totals', totals)
  return Object.entries(totals).map(([product, total]) => ({ [product]: total }))
}

export const computeFooterTotalsFromRows = (rows: any[]): { [key: string]: number } => {
  const totals: { [key: string]: number } = {}

  rows.forEach(row => {
    Object.entries(row).forEach(([key, value]) => {
      if (EXCLUDED_KEYS.has(key)) return
      if (typeof value === 'number' && value > 0) {
        totals[key] = (totals[key] || 0) + value
      }
    })
  })

  return totals
}
